import { c as _c } from "react/compiler-runtime";
import { Stack, Tooltip, Typography, type TooltipProps } from '@mui/material';
import classnames from 'classnames';
import React from 'react';
interface TooltipContentProps {
  isAuthorized?: boolean;
  isFeatureSupported?: boolean;
  title: string | null;
  overrideTitle?: boolean;
}
const TooltipContent = props => {
  const $ = _c(13);
  const shouldShowTitle = props.title && (!props.overrideTitle || props.isAuthorized && props.isFeatureSupported);
  let t0;
  if ($[0] !== props.isAuthorized || $[1] !== props.title || $[2] !== shouldShowTitle) {
    t0 = shouldShowTitle && <Typography className={classnames("text-xs", {
      "font-semibold": !props.isAuthorized
    })} color="var(--mui-palette-primary-dark)">{props.title}</Typography>;
    $[0] = props.isAuthorized;
    $[1] = props.title;
    $[2] = shouldShowTitle;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== props.isAuthorized) {
    t1 = !props.isAuthorized && <Typography width="176px" color="var(--mui-palette-primary-dark)" className="text-xs">An admin has blocked this action for your current user role.</Typography>;
    $[4] = props.isAuthorized;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== props.isAuthorized || $[7] !== props.isFeatureSupported) {
    t2 = props.isAuthorized && !props.isFeatureSupported && <Typography width="176px" color="var(--mui-palette-primary-dark)" className="text-xs">{"In order to use this feature, update the relevant account's permissions version."}</Typography>;
    $[6] = props.isAuthorized;
    $[7] = props.isFeatureSupported;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t0 || $[10] !== t1 || $[11] !== t2) {
    t3 = <Stack marginX="4px" direction="column" gap="4px">{t0}{t1}{t2}</Stack>;
    $[9] = t0;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
};
interface AuthorizationTooltipProps extends Omit<TooltipProps, 'title'> {
  isAuthorized?: boolean;
  isFeatureSupported?: boolean;
  title?: string;
  overrideTitle?: boolean;
}
export const AuthorizationTooltip = props => {
  const $ = _c(17);
  let children;
  let t0;
  let t1;
  let t2;
  let tooltipProps;
  if ($[0] !== props) {
    ({
      children,
      isAuthorized: t0,
      isFeatureSupported: t1,
      overrideTitle: t2,
      ...tooltipProps
    } = props);
    $[0] = props;
    $[1] = children;
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
    $[5] = tooltipProps;
  } else {
    children = $[1];
    t0 = $[2];
    t1 = $[3];
    t2 = $[4];
    tooltipProps = $[5];
  }
  const isAuthorized = t0 === undefined ? true : t0;
  const isFeatureSupported = t1 === undefined ? true : t1;
  const overrideTitle = t2 === undefined ? false : t2;
  let t3;
  if ($[6] !== isAuthorized || $[7] !== isFeatureSupported || $[8] !== overrideTitle || $[9] !== props.title) {
    t3 = props.title || !isAuthorized || !isFeatureSupported ? <TooltipContent isAuthorized={isAuthorized} isFeatureSupported={isFeatureSupported} title={props.title || null} overrideTitle={overrideTitle} /> : undefined;
    $[6] = isAuthorized;
    $[7] = isFeatureSupported;
    $[8] = overrideTitle;
    $[9] = props.title;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const tooltipTitle = t3;
  let t4;
  if ($[11] !== children) {
    t4 = <span>{children}</span>;
    $[11] = children;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t4 || $[14] !== tooltipProps || $[15] !== tooltipTitle) {
    t5 = <Tooltip {...tooltipProps} title={tooltipTitle}>{t4}</Tooltip>;
    $[13] = t4;
    $[14] = tooltipProps;
    $[15] = tooltipTitle;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};